import { render, staticRenderFns } from "./ComboNotification.vue?vue&type=template&id=7f7788f0&"
import script from "./ComboNotification.vue?vue&type=script&lang=js&"
export * from "./ComboNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports